var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "star",
    viewBox: "0 0 640 640",
    fill: "none",
    stroke: "#eeee00",
    strokeWidth: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    .fill {fill: #eeee00}\r\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M472.2,586.5l-147.9-79.6c-4.2-2.3-9.3-2.3-13.6-0.1l-149.5,76.7c-10.8,5.5-23.2-3.7-21.1-15.6l30-165.3c0.9-4.7-0.7-9.6-4.1-13L47,271.1c-8.6-8.5-3.7-23.2,8.4-24.9l166.5-22.5c4.8-0.6,8.9-3.6,11.1-7.9l75.8-149.9c5.5-10.8,21-10.7,26.2,0.3l72.8,151.4c2.1,4.3,6.2,7.4,10.9,8.1l166,25.8c12,1.9,16.6,16.7,7.9,25L471.1,392.5c-3.5,3.3-5.1,8.2-4.3,12.9l26.8,165.8C495.5,583.2,482.9,592.2,472.2,586.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.dcd069d557a0a941c9548a9c26ce7004.svg";
export { ForwardRef as ReactComponent };